(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fullscreen-slider-hero"] && !Shopify.designMode) return;
  try {
    
  class FullscreenSlider extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this._docEvents = [];
      this._winEvents = [];
      this.setup();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      clearTimeout(this._settleTimer);
      this._docEvents.forEach(function (entry) {
        document.removeEventListener(entry[0], entry[1]);
      });
      this._winEvents.forEach(function (entry) {
        window.removeEventListener(entry[0], entry[1]);
      });
      this._docEvents = [];
      this._winEvents = [];
    }

    setup() {
      this.viewport = this.querySelector('.fs-slider__viewport');
      this.track = this.querySelector('.fs-slider__track');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.fs-slider__slide'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.fs-slider__dot'));
      this.live = this.querySelector('.fs-slider__live');
      this.count = this.slides.length;
      this.index = 0;
      this.pos = 0;
      this.busy = false;
      this.paused = false;

      this.transition = this.dataset.transition === 'fade' ? 'fade' : 'slide';
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplayWanted = this.dataset.autoplay === 'true' && !this.reduceMotion;
      this.speed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.swipeEnabled = this.dataset.swipe === 'true';

      this.bindEditorEvents();
      this.setupHeight();

      if (this.count < 2) return;

      if (this.transition === 'slide') this.buildLoop();
      this.bindControls();
      this.bindKeyboard();
      if (this.swipeEnabled) this.bindSwipe();
      if (this.pauseOnHover) this.bindHover();
      this.bindVisibility();

      this.render(false);
      if (this.autoplayWanted) this.startAutoplay();
    }

    /* Volle Bildschirmhoehe an eine feste Kopfzeile anpassen.
       Nur aktiv, wenn die transparente Kopfzeile deaktiviert ist: misst den
       Abstand des Sliders vom Seitenanfang (= Hoehe der Kopfzeile, wenn dieser
       Abschnitt der erste ist) und fuellt exakt den Bereich darunter. */
    setupHeight() {
      if (this.dataset.fitBelowHeader !== 'true') return;
      var self = this;
      var measure = function () {
        var top = self.getBoundingClientRect().top + window.scrollY;
        if (top < 0) top = 0;
        self.style.setProperty('--fs-header-offset', Math.round(top) + 'px');
      };
      measure();
      setTimeout(measure, 350);
      this.onWindow('resize', measure);
      this.onWindow('load', measure);
    }

    onWindow(type, handler) {
      window.addEventListener(type, handler);
      this._winEvents.push([type, handler]);
    }

    /* Nahtlose Endlos-Schleife fuer "Schieben": je ein Klon vorne/hinten. */
    buildLoop() {
      var cloneFirst = this.slides[0].cloneNode(true);
      var cloneLast = this.slides[this.count - 1].cloneNode(true);
      [cloneFirst, cloneLast].forEach(function (clone) {
        clone.classList.add('fs-slider__slide--clone');
        clone.classList.remove('is-active');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.removeAttribute('id');
        Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
          if (attr.name.indexOf('data-shopify') === 0) clone.removeAttribute(attr.name);
        });
      });
      this.track.insertBefore(cloneLast, this.slides[0]);
      this.track.appendChild(cloneFirst);
      this.pos = 1;
      this.applyTransform(false);
      this.track.addEventListener('transitionend', this.onTransitionEnd.bind(this));
    }

    applyTransform(animate) {
      this.track.style.transition = animate ? '' : 'none';
      this.track.style.transform = 'translateX(-' + (this.pos * 100) + '%)';
      if (!animate) {
        void this.track.offsetWidth;
        this.track.style.transition = '';
      }
    }

    onTransitionEnd(event) {
      if (event.target !== this.track || event.propertyName !== 'transform') return;
      clearTimeout(this._settleTimer);
      this.settle();
    }

    settle() {
      this.busy = false;
      if (this.pos > this.count) {
        this.pos = 1;
        this.applyTransform(false);
      } else if (this.pos < 1) {
        this.pos = this.count;
        this.applyTransform(false);
      }
    }

    goTo(target, direction) {
      target = ((target % this.count) + this.count) % this.count;
      if (direction === 0 && target === this.index) return;

      if (this.transition === 'fade') {
        this.index = target;
        this.render(true);
        return;
      }

      if (this.busy) return;
      this.busy = true;
      if (direction === 1) this.pos += 1;
      else if (direction === -1) this.pos -= 1;
      else this.pos = target + 1;
      this.index = target;
      this.applyTransform(true);
      this.render(true);

      clearTimeout(this._settleTimer);
      this._settleTimer = setTimeout(this.settle.bind(this), 900);
    }

    next() { this.goTo(this.index + 1, 1); }
    prev() { this.goTo(this.index - 1, -1); }

    render(announce) {
      var index = this.index;
      this.slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });
      this.dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (announce && this.live) {
        this.live.textContent = 'Bild ' + (index + 1) + ' von ' + this.count;
      }
    }

    /* ---- Autoplay ---- */
    startAutoplay() {
      if (!this.autoplayWanted) return;
      this.stopAutoplay();
      this.timer = setInterval(this.next.bind(this), this.speed);
    }

    stopAutoplay() {
      clearInterval(this.timer);
    }

    resumeAutoplay() {
      if (this.autoplayWanted && !this.paused && !document.hidden) this.startAutoplay();
    }

    /* ---- Pfeile & Punkte ---- */
    bindControls() {
      var self = this;
      var prev = this.querySelector('.fs-slider__arrow--prev');
      var next = this.querySelector('.fs-slider__arrow--next');
      if (prev) prev.addEventListener('click', function () { self.prev(); self.resumeAutoplay(); });
      if (next) next.addEventListener('click', function () { self.next(); self.resumeAutoplay(); });
      this.dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { self.goTo(i, 0); self.resumeAutoplay(); });
      });
    }

    /* ---- Tastatur (Pfeiltasten bei Fokus) ---- */
    bindKeyboard() {
      var self = this;
      this.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          self.prev();
          self.resumeAutoplay();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          self.next();
          self.resumeAutoplay();
        }
      });
    }

    /* ---- Pause bei Mauszeiger / Fokus ---- */
    bindHover() {
      var self = this;
      this.addEventListener('mouseenter', function () { self.paused = true; self.stopAutoplay(); });
      this.addEventListener('mouseleave', function () { self.paused = false; self.resumeAutoplay(); });
      this.addEventListener('focusin', function () { self.paused = true; self.stopAutoplay(); });
      this.addEventListener('focusout', function (event) {
        if (!self.contains(event.relatedTarget)) { self.paused = false; self.resumeAutoplay(); }
      });
    }

    /* ---- Pause bei verstecktem Tab ---- */
    bindVisibility() {
      var self = this;
      var handler = function () {
        if (document.hidden) self.stopAutoplay();
        else self.resumeAutoplay();
      };
      document.addEventListener('visibilitychange', handler);
      this._docEvents.push(['visibilitychange', handler]);
    }

    /* ---- Touch-/Pointer-Swipe ---- */
    bindSwipe() {
      var self = this;
      var startX = 0;
      var startY = 0;
      var active = false;
      var moved = false;
      var THRESHOLD = 45;

      this.viewport.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        active = true;
        moved = false;
        startX = event.clientX;
        startY = event.clientY;
        try { self.viewport.setPointerCapture(event.pointerId); } catch (err) {}
      });

      this.viewport.addEventListener('pointermove', function (event) {
        if (!active) return;
        if (Math.abs(event.clientX - startX) > 8) moved = true;
      });

      var finish = function (event) {
        if (!active) return;
        active = false;
        var dx = event.clientX - startX;
        var dy = event.clientY - startY;
        if (moved && Math.abs(dx) > THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          self.suppressClick();
          if (dx < 0) self.next();
          else self.prev();
          self.resumeAutoplay();
        }
      };

      this.viewport.addEventListener('pointerup', finish);
      this.viewport.addEventListener('pointercancel', function () { active = false; });
    }

    /* Unterdrueckt den auf einen Wisch folgenden Klick, damit das Wischen
       nicht versehentlich dem Bild-Link folgt. */
    suppressClick() {
      var block = function (event) {
        event.preventDefault();
        event.stopPropagation();
      };
      this.addEventListener('click', block, { capture: true, once: true });
      var self = this;
      setTimeout(function () {
        self.removeEventListener('click', block, { capture: true });
      }, 400);
    }

    /* ---- Theme-Editor: Auswahl einer Slide springt zur Slide ---- */
    bindEditorEvents() {
      var self = this;
      var onSelect = function (event) {
        var slide = event.target.closest ? event.target.closest('.fs-slider__slide') : null;
        var i = slide ? self.slides.indexOf(slide) : -1;
        if (i !== -1) {
          self.stopAutoplay();
          self.goTo(i, 0);
        }
      };
      var onDeselect = function () { self.resumeAutoplay(); };
      document.addEventListener('shopify:block:select', onSelect);
      document.addEventListener('shopify:block:deselect', onDeselect);
      this._docEvents.push(['shopify:block:select', onSelect]);
      this._docEvents.push(['shopify:block:deselect', onDeselect]);
    }
  }

  if (!customElements.get('fullscreen-slider')) {
    customElements.define('fullscreen-slider', FullscreenSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
